// export const API_BASE_URL = "http://localhost:5000";
// export const API_BASE_URL = "http://15.207.106.137:5000";
// export const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}:${process.env.NODE_PORT}`;
export const API_BASE_URL = "https://digitalindiaflex.com";
